export const llSystemSupportCardBrands = [
  'AMEX',
  'DINERSCLUB',
  'DISCOVER',
  'JCB',
  'MASTERCARD',
  'VISA',
  'UNIONPAY',
];



